import { useState } from 'react';
import { Sidebar } from '../../components/feature/Sidebar';
import { TopBar } from '../../components/feature/TopBar';
import { WorkOrderKanban } from './components/WorkOrderKanban';
import { WorkOrderList } from './components/WorkOrderList';
import { WorkOrderForm } from './components/WorkOrderForm';
import { WorkOrderFilters } from './components/WorkOrderFilters';

export default function DashboardPage() {
  const [view, setView] = useState<'kanban' | 'list'>('kanban');
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    priority: 'all',
    assignee: 'all',
    search: ''
  });

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      
      <div className="flex-1 flex flex-col">
        <TopBar 
          title="Ordens de Serviço" 
          subtitle="Gerencie e acompanhe todas as ordens de serviço"
          actions={
            <div className="flex items-center space-x-3">
              <div className="flex items-center bg-gray-100 rounded-lg p-1">
                <button
                  onClick={() => setView('kanban')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    view === 'kanban'
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <i className="ri-kanban-view mr-2"></i>
                  Kanban
                </button>
                <button
                  onClick={() => setView('list')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    view === 'list'
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <i className="ri-list-check mr-2"></i>
                  Lista
                </button>
              </div>
              
              <button
                onClick={() => setShowForm(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-add-line text-lg"></i>
                <span>Nova Ordem de Serviço</span>
              </button>
            </div>
          }
        />
        
        <div className="flex-1 overflow-auto p-8">
          <WorkOrderFilters filters={filters} onFilterChange={setFilters} />
          
          <div className="mt-6">
            {view === 'kanban' ? (
              <WorkOrderKanban filters={filters} />
            ) : (
              <WorkOrderList filters={filters} />
            )}
          </div>
        </div>
      </div>

      {showForm && (
        <WorkOrderForm onClose={() => setShowForm(false)} />
      )}
    </div>
  );
}
